module.exports = __webpack_public_path__ + "static/img/istockphoto-497981184-2048x2048.d66203d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/istockphoto-497981184-2048x2048.png
// module id = 775
// module chunks = 5